export default {
    exclude_paths:false,
    paths:[
        '/inventory'
    ],
    roles:[
        'admin'
    ],
    region:'leftDrawer',//header|topA|topB|left|mainTop|mainBottom|right|bottomB|bottomA|footer
    preload:false,
    weight:1
}
